module.exports = __webpack_public_path__ + "assets/img/btn-view-4d54cd86.png";